"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// jsan stringify options
var _default = {
  refs: false,
  // references can't be resolved on the original Immutable structure
  date: true,
  "function": true,
  regex: true,
  undefined: true,
  error: true,
  symbol: true,
  map: true,
  set: true,
  nan: true,
  infinity: true
};
exports["default"] = _default;